module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Stripe")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 pb-4"
  }, [(_vm.isLoadingIntegrationDetails) ? _c('div', {
    staticClass: "text-center w-100 p-3"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "pb-3"
  }, [(_vm.showTestKeysWarning) ? _c('div', {
    staticClass: "mb-3 border-color-6 p-2 radius-normal bg-red-pale"
  }, [_vm._v("\n                    Warning: You are using a Test Stripe Account, make sure to use Live Keys when you are ready to sell your products via Widget\n                ")]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stripeSecretKey"
    }
  }, [_vm._v("Secret Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integrationDetails.stripeSecretKey),
      expression: "integrationDetails.stripeSecretKey"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "stripeSecretKey",
      "type": "text"
    },
    domProps: {
      "value": (_vm.integrationDetails.stripeSecretKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.integrationDetails, "stripeSecretKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stripePublicKey"
    }
  }, [_vm._v("Public Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integrationDetails.stripePublicKey),
      expression: "integrationDetails.stripePublicKey"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "stripePublicKey",
      "type": "text"
    },
    domProps: {
      "value": (_vm.integrationDetails.stripePublicKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.integrationDetails, "stripePublicKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "isIntegrated": _vm.currentIntegration.integrationStatus == 1,
      "showSaveBtn": true
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.disableIntegration()
      },
      "saveIntegration": _vm.saveIntegration,
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-140ce59a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-140ce59a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/stripeIntegrate.vue
// module id = 3174
// module chunks = 0